const messages = {
    scanWithBankApp: "使用您的银行应用扫码",
    scanWithCreditCardApp: "使用您的信用卡应用扫码",
    scanOrOpenApp: "扫码或打开应用完成支付",
    scanForPayment: "扫码支付",
    scanWithBankApp: '使用银行应用扫码支付',
    changePaymentWarning: "更换支付方式后，之前的 QR Code 将失效。请仅使用新的支付方式。",
    swapShop: "您要切换到<br>新店铺吗？",
    swapShopDespt: "之前店铺选择的商品将被保存，可以稍后再下单",
    sorryForInconvenient: '对造成的不便深表歉意',
    openAt: '营业时间',
    shopIsClosedToday: '今日休业',
    checkOrderedItem: '查看已点的菜品',
    tryAgainIn: '请在此时间后重试',
    lockUserPIN: "PIN 输入错误超过5次",
    lockUserPINDespt: "请5分钟后重试",
    inValidPIN: 'PIN 不正确',
    enterPasswordToAccessMenu: "输入 PIN 进入菜单",
    customersCanGetPasswordFromStaff: "顾客可以向服务员获取 PIN",
    tableNotAvailable: "餐桌不可用",
    contactStaffToOpenTable: "请联系服务员开桌",
    outOfRestaurantRange: "不在餐厅范围内",
    phoneIsMoreThan100MetersAwayFromRestaurant: "您的手机距离餐厅超过100米",
    restaurantIsCurrentlyClosed: "餐厅目前已关闭",
    restaurantOpenHours: "厨房营业时间",
    packingSize: '包装规格',
    shippingDelivery: '配送',
    waitForPaymentDelivery: '待付款',
    readyForPcikup: '待取货',
    noNotifyNow: "暂无通知",
    noNotifyNowDespt: "当您开始使用服务后，通知将显示在这里",
    newAddressDespt: "为便于配送，请标注正确的目的地并允许访问您的位置",
    deleteAddressSuccess: '地址删除成功',
    createProfileSuccess: "个人资料创建成功",
    ex: '例如',
    receiverName: '收件人姓名',
    editAddress: '编辑地址',
    nameInputInvalid: '姓名不正确',
    openInGoogleMap: '打开 Google Map',
    pleaseSelectPaymentMethod: '请选择支付方式',
    noDeliveryAddress: '未找到配送地址',
    noDeliveryAddressDespt: '请添加配送地址信息',
    deliveryType: '配送',
    pickupType: '自取',
    shopIsClose: '店铺已关闭',
    openingHoursDespt: '营业时间',
    contactShop: '联系店铺',
    pickupAtShop: '自取',
    thanksForOrderingDespt: '感谢您的惠顾。<br>期待再次为您服务！',
    deliveredSuccess: '已送达',
    expireIn: '到期时间',
    waitForPayment: '待付款',
    waitForPaymentDespt: "请等待系统确认付款。<br>如尚未付款，请在规定时间内完成支付，以避免订单被取消。",
    newOrderIn: '新订单',
    inputRequestDetails: '请输入需求详情',
    notification: '通知',
    noticeIfOrderReady: '您的订单准备好取货时我们会通知您',
    orderIsReady: '您的订单已准备好取货',
    thanksForOrdering: '感谢使用我们的服务',
    toPay: '去支付',
    letOrder: '前往菜单页面开始点餐',
    noTransaction: '暂无交易',
    menulists: '菜单列表',
    editPersonalDetails: '编辑信息',
    trackOrder: '订单跟踪',
    myAccount: '我的账户',
    cart: '购物车',
    helpCenter: '帮助中心',
    allPurchaseHistory: '购买记录',
    purchaseHistory: '购买记录',
    personalInfo: '个人信息',
    cutlery: '餐具',
    km: '公里',
    totalAmountSum: '合计',
    selectedItemList: '已选商品',
    iAm: '我是',
    orderedBy: '下单人',
    shareQRtoFriend: '分享 QR Code',
    share: '分享',
    hasItemInBasket: '购物篮中有商品',
    hasItemInBasketDespt: '别忘了提交到厨房',
    updatedAtQR: '更新于',
    orderSent: '订单已发送至厨房',
    orderSentDespt: '餐厅正在为您准备食物',
    checkGramdTotalIn: '您可以在此处查看总金额',
    vatNotInclude: '此价格不含税费、服务费和折扣',
    accept: '接受',
    termOfService: '服务条款',
    onPending: '待处理',
    OnSuccessOrder: '成功',
    prepareingOrder: '准备中',
    deliveringOrder: '配送中',
    pickupOrderReady: '待取货',
    pickedupOrder: '已取货',
    deliveredOrder: '已送达',
    shopReceivedOrder: '店铺已接单',
    orderId: '订单号',
    orderDetails: '订单详情',
    deliveryFee: '配送费',
    searchDriver: '正在寻找骑手',
    driverFrom: '骑手来自',
    change: '更换',
    deliveryAddress: '配送地址',
    location: '位置',
    addressName: '地址名称',
    addressNameDespt: '例如：公寓名称、小区名称',
    addressDescription: '详细地址',
    addressDescriptionDespt: '例如：楼栋号、巷弄',
    noteToDriver: '给骑手的备注',
    noteToDriverDespt: '例如：放在入口处的桌上',
    inputAddressForm: '输入配送地址',
    plsPinAddress: '标注您的位置',
    pinLocation: '标注配送位置',
    createNewAddress: '新建地址',
    savedAddress: '已保存的地址',
    phoneNumber: '手机号码',
    noRequired: '选填',
    resendCode: '重新发送验证码',
    didNotGetCode: '没收到验证码？',
    resendIn: '重新发送倒计时',
    next: '下一步',
    createAccount: '创建账户',
    createAccountDespt: '请填写以下表格以创建账户',
    sendCodeViaSMS: '通过短信发送验证码',
    inputOTP: '输入 OTP',
    inputOTPDespt: '请输入发送到的6位验证码',
    termAndPolicy: '条款和政策',
    termAndPolicy1: '使用我们的服务即表示您同意',
    termAndPolicy2: '点击阅读完整的条款和政策',

    loginWithPhoneNumber: '手机号登录',
    loginWithPhoneNumberDespt: '输入您的手机号以接收 OTP 进行身份验证',
    backToOrder: '返回菜单',
    PaymentMethod: '支付',
    paymentAmount: '支付金额',
    paymentConfirmation: '确认支付',
    cancelPayment: '取消支付',
    paidSuccess: '支付完成',
    haveNotPurchased: '尚未付款',
    haveNotPurchased2: '如支付失败，请联系服务员',
    canNotOrderItem: '支付过程中无法点餐',
    checkPaymentStatus: '查看状态',
    pendingPayment: '待付款',
    askForReceipt: '如需发票，请联系服务员',
    paymentSuccess: '支付成功',
    summaryPayment: '汇总',
    numberOfGuest: '用餐人数',
    closeTab: '关闭',
    addCredit: '添加信用卡',
    QRPayment: 'QR 支付',
    cardPayment: '信用卡',
    payWithStaff: '柜台支付',
    selectPaymentMethod: '选择支付方式',
    checkOut: '结账',
    startOrderBeforeCallStaff: '请先点餐再呼叫服务员',
    basket: '购物篮',
    spoon: '请求餐具',
    knife: '请求刀具',
    chopstick: '请求筷子',
    cup: '请求杯子',
    plate: '请求盘子',
    glass: '请求玻璃杯',
    payBill: '请求结账',
    viewAll: '查看全部',
    recommendMenu: '推荐',
    OnSuccess: '成功',
    OnPreparing: '准备中',
    messageSent: '请等待服务员',
    outOfStock: '已售罄',
    QRCode: 'QR Code',
    GenerateQRCode: '生成 QR Code',
    ForQROrder: '用于点餐和店内服务请求',
    QROrderDescription: '您可以生成 QR Code 供顾客扫码点餐和请求店内服务',
    SelectTable: '选择餐桌并输入用餐人数。',
    shopname: '店铺名称',
    numberOfCustomer: '顾客人数（人）',
    numberOfCustomerDescription: '输入顾客人数，最少1人',
    currentUser: '用户',
    guest: '访客',
    orderItem: '订单汇总',
    orderItemNav: '订单汇总',
    callStaff: '呼叫服务员',
    callStaffDialog: '您需要什么帮助？',
    cutlery: '请求餐具',
    seasoning: '请求调味料',
    refillDrink: '请求续杯',
    other: '其他',
    tableNumber: '桌号',
    menuList: '菜单',
    selectedItem: '点餐',
    selectedItemNav: '点餐',
    checkOrderBeforeConfirm: '请在提交前确认订单详情和总额',
    checkOrderBeforeConfirm2: '',
    startOrder: '开始点餐',
    foodCategory: '分类',
    searchByName: '按名称搜索商品...',
    noPreduct: '暂无商品',
    noSelectedProduct: '未选择商品',
    noSelectedProductDespt: '选择商品后，所选列表将显示在此页面',
    backToMenu: '前往菜单',
    removeSelected: '确定要删除此商品吗？',
    confirmOrder: '提交订单',
    endOfTransection: '服务结束',
    endOfTransectionDialog: '如有使用问题，请联系服务员',
    note: '备注',
    orderTime: '下单时间',
    orderMoreFood: '返回主菜单',
    orderPreparing: '厨师正在准备您的餐食，请稍候。很快就会上菜',
    orderPreparing2: '',
    sendingOrder: '正在将您的订单发送到厨房...',
    login: '登录',
    forgetPassword: '忘记密码',
    loginWithGmail: '使用 Gmail 登录',
    or: '或',
    loginAsStaff: '员工登录',
    billOrder: '账单',
    table: '桌号',
    billOrderDialog: '扫描 QR Code 查看菜单并点餐',
    billOrderDialog2: '如有使用问题，请联系服务员',
    selectTableAleart: '请先选择餐桌再生成 QR Code',
    emptyCartDialog: '暂无交易',
    emptyCartDialogDespt: '确认订单后，已点菜品列表将显示在此页面',
    served: '已上菜',
    contactOurStaff: '联系服务员',
    contactOurStaff2: '如需帮助',
    addToCart: '加入购物车',
    noteToShop: '给商家的备注',
    addYourRequest: '添加您的需求',
    branchName: '分店名称',
    businessType: '业务类型',
    taxID: '税号',
    vat: '税',
    exclusive: '不含税',
    inclusive: '含税',
    serviceCharge: '服务费',
    address: '地址',
    address1: '地址行1',
    address2: '地址行2',
    tel: '电话',
    businessType1: '一般',
    businessType2: '餐厅',
    businessType3: '酒店',
    shopopen: '营业 - 休息',
    open: '营业',
    closed: '休息',
    languagetxt: '语言',
    language: '语言和时区',
    languageTH: '泰语',
    languageEN: '英语',
    setting: '设置',
    shop: '店铺',
    timezone: '时区',
    deliveryProviders: '配送服务商',
    adddeliveryProviders: '添加服务商',
    lastUpdate: '最近更新',
    logo: 'Logo',
    updateData: '更新数据',
    submit: '提交',
    cancel: '取消',
    normal: '正常',
    loading: '加载中...',
    editing: '编辑中',
    confirmUpdate: '确定要更新数据吗？',
    selectedShoptype: '选择业务类型...',
    selectshop: '选择分店',
    save: '保存',
    reporttxt: '报表',
    general: '常规',
    signOut: '退出登录',
    registration: '',
    unit: '单位',
    category: '分类',
    product: '商品',
    export: '导出',
    exportKBank: '导出 K-Bank',
    date: '日期',
    to: '至',
    status: '状态',
    vatAmount: '税额',
    netTotalNonVAT: '合计（不含税）',
    receiptNumber: '收据号',
    grandTotal: '总计',
    netAmountVATTotal: '小计',
    netTotalIncVAT: '合计（含税）',
    proofOfPayment: '付款凭证',
    paymentType: '支付类型',
    paymentType0: '现金',
    paymentType1: '信用卡',
    paymentType2: '优惠券',
    paymentType3: 'Quickpay',
    paymentType4: 'Promptpay',
    paymentType5: 'Alipay',
    paymentType6: '定金',
    paymentType7: '配送',
    paymentType8: '在线',
    paymentType9: 'Line Pay',
    paymentType10: '自定义支付',
    paymentType12: 'KBank',
    paid: '已付金额',
    sentSuccessfully: '发送成功',
    pluCode: '条形码',
    netAmount: '净额',
    discount: '折扣',
    timeOfOrder: '下单时间',
    orderDate: '下单日期',
    preparing: '准备中',
    paymentDetail: '付款详情',
    orderNumber: '订单号',
    delivered: '到期日',
    deliveredDate: '配送时间',
    payment: '付款',
    productName: '商品名称',
    quantity: '数量',
    priceUnit: ' 单价',
    baht: '泰铢',
    profit: '利润',
    sales: '销售额',
    billAmount: '账单金额',
    total: '合计',
    bill: '账单',
    discountAmount: '折扣金额',
    averageBill: '均单',
    voidbillTotal: '作废账单合计',
    salesByDaily: '日销售额',
    salesByMonth: '月销售额',
    bestSellers: '畅销商品',
    bestSellerstype: '畅销类别',
    salesBydate: '按日期销售额',
    number: '序号',
    categoryName: '类别名称',
    newOrder: '发送订单',
    reject: '拒绝',
    inProgressTime: '处理时间',
    rejectTime: '拒绝时间',
    cancelTime: '取消时间',
    cause: '原因',
    preparingToShip: '准备中',
    totalAmount: '合计',
    order: '订单',
    deposit: '定金',
    billSave: '保存',
    ReceivingOrder: '开桌/接单',
    orderNo: '订单号',
    remark: '备注',
    receiptStatus: '收据状态',
    back: '返回',
    detail: '详情',
    countSales: '数量',
    onhandQty: '库存余额',
    stdCost: '成本',
    employees: '员工',
    employeesname: '员工姓名',
    salesTotal: '销售总额',
    totalBill: '总账单数',
    billActive: '有效账单数',
    billVoice: '作废账单数',
    billDeposit: '定金账单数',
    discountItem: '商品折扣合计',
    billDiscountAmount: '账单折扣合计',
    billDiscount: '折扣账单数',
    payTotal: '付款合计',
    deliveryProvider: '配送服务商',
    deliveryDetail: '配送详情',
    customDetail: '自定义支付详情',
    customPaymentName: '自定义支付名称',
    firstInvoiceNO: '首单号',
    lastInvoiceNO: '末单号',
    roundNo: '轮次',
    closeAt: '关闭时间',
    closeBy: '关闭人',
    totalCashSales: '现金销售总额',
    initialChange: '初始备用金',
    totalCashIn: '现金收入合计',
    totalCashOut: '现金支出合计',
    actualInDrawer: '收银箱实际金额',
    expectedInDrawer: '收银箱应有金额',
    difference: '差额',
    voidBillDetail: '作废账单详情',
    cancelBy: '取消人',
    cancelDate: '取消日期',
    searchByEmployees: '按员工搜索',
    search: '搜索',
    timeIn: '签到',
    timeOut: '签退',
    time: '时间',
    hours: '小时',
    seconds: '秒',
    netTotal: '合计',
    reason: '原因',
    searchByProduct: '按商品搜索',
    sortBy: '排序方式',
    last: '最近',
    price: '商品价格',
    sortByNumMin: '最低价',
    sortByNumMax: '最高价',
    documentNo: '单据号',
    transactionType: '交易类型',
    updatedBy: '更新人',
    transactionType1: '销售',
    transactionType2: '退款',
    transactionType3: '入库',
    transactionType4: '出库',
    transactionType5: '调整入库',
    transactionType6: '调整出库',
    transactionType7: '兑换积分',
    transactionType8: '删除入库',
    transactionType9: '删除出库',
    transactionType10: '编辑入库',
    transactionType11: '编辑出库',
    billNo: '账单号',
    docTotal: '合计',
    customer: '客户',
    username: '用户名',
    dateOfBill: '账单日期',
    selectDate: '选择日期',
    dialogSelectCategory: '请选择类别进行搜索',
    dialogUpdateDocumentSuccess: '单据更新成功',
    dialogfound: '输入的信息不正确。',
    isVatIncluded: '是否含税',
    vatIccludes: '增值税',
    confirmStock: '确认库存',
    confirm: '确认',
    deleteDoc: '删除单据',
    confirmUpdateDocModal: '确定要更新库存单据吗？',
    confirmSaveDoc: '确认保存单据',
    confirmDeleteDoc: '确认删除单据',
    confirmDeleteModal: '确定要删除库存单据吗？',
    dialogSaveDocumentSuccess: '单据保存成功',
    createStockIn: '创建入库单',
    confirmSaveDocModal: '确定要保存库存单据吗？',
    selectShopPlease: '请选择店铺',
    selectProductPlease: '请选择商品',
    duplicateProduct: '您已选择了此商品。',
    productInvilid: '所选商品无效，请联系系统管理员。',
    confirmStockOut: '确认出库',
    dialogSaveDocumentOutSuccess: '单据保存成功',
    confirmSaveDocStockOutModal: '确定要保存出库单据吗？',
    adjustDocType: '调整单据类型',
    adjustDocType1: '增加',
    adjustDocType2: '减少',
    beforeAdjust: '调整前库存',
    afterAdjust: '调整后库存',
    adjust: '调整库存',
    createDoucument: '创建单据',
    transferType: '调拨类型',
    transferType1: '调入',
    transferType2: '调出',
    new: '新建',
    finish: '完成',
    refDocument: '参考单据',
    statusDoc: '单据状态',
    dialogSaveTransferDocumentSuccess: '调拨单据创建成功',
    destinationShop: '目标店铺',
    destinationShopBranch: '目标分店',
    sourceBranch: '来源分店',
    sourceShop: '来源店铺',
    sourceAddress: '来源地址',
    destinationAddress: '目标地址',
    saveTransfer: '保存库存调拨',
    confirmSaveTransfer: '确定要保存库存调拨吗？',
    savinserviceChargegDoc: '正在保存单据',
    selectdestinationPlease: '请选择目标分店',
    validatedestinationproduct: "目标分店没有此商品",
    validateProduct: '请选择商品',
    created_by: '创建人',
    receive: '接收',
    updateDoc: '更新单据',
    cancelDoc: '取消单据',
    confirmCancelDoc: '确定要取消此单据吗？',
    cancelingDoc: '正在取消单据',
    updatingDoc: '正在更新单据',
    updateDocFail: "无法更新单据",
    cancelDocSuccess: '单据取消成功',
    cancelDocFail: "无法取消单据",
    refDocumentTransfer: '参考单据',
    comfrimTransferIn: '确认调入库存',
    dilogcomfrimTransferIn: '确定要调入库存吗？',
    transferInDetail: '库存调拨详情',
    totalNet: '净合计',
    confirmAdjust: '确认库存调整',
    createStockOut: '创建出库单',
    favorite: '收藏',
    isOnScreen: '显示在屏幕',
    negotiatePrice: '议价',
    productTypeP: '普通商品',
    productTypeBOM: '组合商品',
    productTypeSN: '序列号商品',
    productTypeSV: '服务（无库存）',
    productPLU: '其他包装规格',
    productBOM: '物料',
    productSN: 'Serial Number',
    morePrice: '其他价格',
    cost: '成本',
    quantityPrice: '数量',
    exceedUc: '价格',
    changeImg: '更换图片',
    addProduct: '添加商品',
    selectImg: '选择图片',
    deleteImg: '删除图片',
    selectImgFromPC: '从电脑选择图片',
    confirmSaveImgDialog: '确定要保存商品吗？',
    confirmSaveImg: '确认保存商品。',
    addPrice: '添加价格',
    editPrice: '编辑价格',
    dialigDeleteProduct: '确定要删除商品吗？',
    confirmDeleteProduct: '确认删除此商品。',
    productType: '商品类型',
    countProduct: '商品数量',
    addUnit: '添加单位',
    editUnit: '编辑单位',
    active: '启用',
    inactive: '停用',
    confirmSaveUnitDialog: '确定要保存单位吗？',
    confirmSaveUnit: '确认保存此单位。',
    dialigDeleteUnit: '确定要删除单位吗？',
    confirmDeletUnit: '确认删除此单位。',
    confirmSaveCategoryDialog: '确定要保存类别吗？',
    confirmSaveCategory: '确认保存此类别。',
    dialigDeleteCategory: '确定要删除类别吗？',
    confirmDeletCategory: '确认删除类别。',
    addCategory: '添加类别',
    editCategory: '编辑类别',
    bgColor: '背景色',
    selectbgColor: '选择背景色',
    validateCategoryname: '请输入类别名称。',
    sequence: '排序',
    enterProduct: '请输入商品名称。',
    enterPrice: '请输入商品价格。',
    selectCategory: '请选择商品类别。',
    selectUnit: '请选择商品单位。',
    confirmSaveProduct: '确定要保存此商品吗？',
    confirmSaveProductPrice: '确定要保存其他价格吗？',
    validatepackQty: '请输入单价。',
    validatepackUc: '请输入价格。',
    validatePRU: '数据重复，请重新输入。',
    createProductSuccess: '商品创建成功',
    addSerial: '添加序列号',
    add: '添加',
    createSerial: '生成序列号',
    available: '可售',
    soldOut: '已售罄',
    deleteSuccess: '删除成功',
    enterSerial: '请输入序列号',
    confirmSaveSerial: '确定要保存此序列号吗？',
    confirmDelete: '确定要删除此序列号吗？',
    addProductPLU: '添加包装规格',
    img: '图片',
    SKURatio: '比率',
    editProductPLU: '编辑包装规格',
    enterSKURatio: '请输入比率',
    comfrimDeletePLU: '确定要删除此包装规格吗？',
    useStepPrice: '使用阶梯价',
    addBOM: '添加物料',
    confirmSaveBOM: '确定要保存物料吗？',
    user: '用户',
    userDetail: '用户详情',
    planDetail: '套餐详情',
    currentPlan: '当前套餐',
    expireDate: '到期日期',
    startDate: '开始日期',
    dialogSignOut: '确定要退出登录吗？',
    confirmSignOut: '确认退出',
    countMember: '全部会员',
    addMenber: '添加会员',
    searchMember: '按姓名、邮箱和电话搜索',
    dateOfMember: '注册日期',
    recentVisit: '最近访问',
    memberName: '会员名称',
    email: '邮箱',
    paymentTotal: '付款合计',
    point: '积分',
    pointtxt: '积分',
    postalCode: '邮政编码',
    saveing: '保存中...',
    edit: '编辑',
    editMember: '编辑会员',
    deleteing: '删除中...',
    dialogDeleteMember: '确定要删除会员吗',
    confirmDeleteMember: '确认删除',
    valtdateMember: '请填写信息',
    createMemberSuccess: '会员添加成功！！',
    updateMemberSuccess: '会员编辑成功！！',
    deleteMemberSuccess: '会员删除成功！！',
    onhandQtyMin: '最低库存',
    onhandQtyMax: '最高库存',
    onhandQtySort: '库存余额',
    showProductAll: '全部商品类型',
    updateAt: '最近更新',
    sortName: '名称',
    stockUnit: '单位成本',
    deleteCategory: '类别已删除',
    selectd: '选择',
    searchProduct: '搜索商品',
    reset: '重置',
    selectdProduct: '选择商品',
    information: '信息',
    adjustStockList: '库存调整商品',
    adjustDetail: '添加商品到库存调整列表并设置商品',
    transferoutList: '库存调拨商品',
    addProductTransfer: '添加商品到库存调拨列表并设置商品',
    transferDetail: '商品出库列表并设置商品',
    transferinList: '商品入库列表并设置商品',
    stockOutList: '出库商品',
    addstockOutList: '添加商品到出库列表并设置商品',
    stockinList: '入库商品',
    addProductStockin: '添加商品到入库列表并设置商品',
    checkCount: '盘点库存',
    createAdjustStock: '创建库存调整',
    memberDetail: '会员信息',
    package: '套餐详情',
    startPackate: '套餐开始',
    endPackate: '套餐结束',
    name: '名称',
    productImg: '商品图片',
    fistname: '名',
    lastname: '姓',
    saveMember: '保存信息',
    confirmSaveMember: '确定要保存会员吗',
    yesOrNo: '是或否',
    totaValue: '合计',
    deleteMember: '删除会员',
    frequently: '常购商品',
    recentPurchase: '最近购买',
    paymentDescription: '付款说明',
    validateInfomation: '请输入信息',
    validateTel: '电话号码不正确',
    validateOTP: 'OTP 不正确',
    validateEmail: '邮箱不正确',
    saveSuccess: '保存成功',
    txtcustomer: '客户',
    customerName: '客户名称',
    customerCount: '客户数量',
    addCustomer: '添加客户',
    permissionManage: '权限管理',
    mainMenu: '主菜单',
    page: '页',
    show: '显示',
    delete: '删除',
    administratorTools: '管理员工具',
    deviceName: '设备名称',
    lastSyncProduct: '最近同步',
    version: '版本',
    posstatus: '状态',
    posNumber: 'POS 编号',
    titleSilomconnect: '不错过任何销售，来自',
    updateSilom: '通过 LINE 免费更新每日销售额',
    addfriend: '添加好友',
    enterToReciveService: '点击获取使用服务的验证码。',
    verifyCodeToUsed: '开始使用系统前，您可以点击获取验证码进行身份验证。',
    verifyfivemin: '验证码5分钟内有效。',
    yourVertify: '您的验证码是',
    pressCode: '点击获取验证码',
    exCode: '验证码有效期',
    sessionEx: '登录会话已过期，请重新登录。',
    refresh: '刷新',
    selectedFile: '选择文件',
    fileSize: '文件大小不超过 2 MB。',
    isBeingToUsed: '使用中',
    notInUse: '未使用',
    delete: '删除',
    confirmUpdateInformation: '确认更新信息',
    memberCount: '数量',
    orderMachine: '点餐设备',
    textMember: '会员',
    manageShop: '店铺信息管理',
    lansetting: '店铺语言和时区设置',
    timezoneSetiing: '店铺时区设置',
    deliveryProviderSetting: '店铺配送服务商',
    toolsSetting: '管理店铺 POS 设备',
    checkStockPLU: '商品库存 < 0',
    searching: '搜索中',
    allProduct: '全部商品',
    foundProductOnhand: '发现库存 < 0 的商品',
    confirmAdjustBefor: '确定要由系统自动调整吗？',
    requireAdjust: '是',
    imrequireAdjust: '否',
    islimitItemTodoc: '每份单据最多选择200个商品。',
    barcodePrint: '打印条形码',
    printEx: '打印和预览',
    print: '打印',
    downloadAndExport: '下载并打印',
    selectFormat: '选择纸张格式',
    peperFormat: '纸张格式',
    optional: '可选',
    standardA427: '标准A4 : 27个/页',
    standardA450: '标准A4 : 52个/页',
    standardA460: '标准A4 : 60个/页',
    standardA556: '标准A4 : 56个/页（贴纸尺寸:A5）',
    standardA550: 'A5纸 : 52个/页',
    standardA560: 'A5纸 : 60个/页',
    countBarcode: '条形码数量',
    barcode: '条形码',
    setFontsize: '字体设置',
    accessPermissionDes: '为用户分配访问权限。',
    deleteUser: '确认删除用户',
    confirmDeleteUser: '确定要删除用户吗？',
    passAtless: '密码至少6个字符。',
    inValidPass: '密码不正确',
    createBy: '创建人',
    adjustAutoDes: "如果不进行系统自动更新，商品库存余额可能不正确。",
    addUser: '添加用户',
    isMenu: '在顾客菜单中显示',
    menuSmart: '设置商品菜单',
    smartSettingTitle: '菜单设置',
    smartSetting: '设置 Silom CRM 菜单',
    confirmEnable: '确定要启用菜单吗？',
    confirmDisEnable: '确定要停用菜单吗？',
    confirmSelfOrderEnable: '确定要启用自助点餐菜单吗？',
    confirmSelfOrderDisable: '确定要停用自助点餐菜单吗？',
    enable: '启用',
    disable: '停用',
    usabilityStatus: '已启用',
    manageSmartOnProduct: '您可以在此页面"添加/编辑"要在顾客菜单中显示的商品列表。',
    manageSmartOnCategory: '您可以在此页面"添加/编辑"要在顾客菜单中显示的类别列表。',
    turnonSmart: '并启用菜单',
    manageShopDes: '您可以参考用户手册 -',
    desSmartMenu: '设置商品菜单，用于在 Line 上显示电子菜单，方便顾客访问并自助点餐。',
    link: '链接',
    createTranferOut: '创建调出单据',
    roundingValue: '四舍五入调整',
    limitItems: '最多可选200个商品',
    IncomeCategory: '收入',
    ExpenseCategory: '支出',
    saveBy: '保存人',
    saveDate: '保存日期',
    drawerCate: '类别',
    openingHours: '营业时间',
    shopLocation: '店铺位置',
    sunday: '星期日',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    lat: '纬度',
    lng: '经度',
    shopCoverSetting: '店铺封面设置',
    shopCoverSettingDes: '设置顾客界面显示的店铺封面',
    locationSettingDes: '位置设置',
    updatelocation: '更新位置',
    searchLocation: '搜索位置',
    imaginaryLine: '边界线',
    openingHoursDes: '设置店铺营业时间',
    paymentDescriptionConfig: '选择支付方式',
    creditCard: '信用卡',
    promptPay: 'Promptpay',
    coupon: '优惠券',
    quickpay: 'Krungsri Quick Pay',
    alipay: 'Alipay',
    linepay: 'Rabbit LINE Pay',
    thaidotcom: 'Thai Dot Com Payment',
    mounth: '月',
    dayMY: '日期',
    item: '项目',
    byStockIn: '入库',
    stockOutOther: '其他',
    drawerSales: '销售额',
    sumIncomeExpenses: '收支汇总',
    incomeOther: '其他收入',
    loss: '亏损',
    grossProfit: '毛利润',
    newUser: '新用户',
    userType: '用户类型',
    password: '密码',
    confirmPassword: '确认密码',
    ParticipatingProducts: '选择商品',
    descriptionSilomOrder: '选择 order.silompos.com 的商品',
    cashierManagement: '收银员管理',
    cashierManageButton: '管理',
    cashierUsernamePassword: '设置用户名/密码',
    cashierCRUDDescription: '用于登录 order.silompos.com',
    password: '密码',
    placeholderPassword: '至少6个字符',
    resetPassword: '重置密码',
    oldPassword: '旧密码',
    oldPasswordPlaceholder: '旧密码',
    newPassword: '新密码',
    purchaseDetail: '购买详情',
    uploadImage: '上传图片',
    keyword: '关键词',
    firstname: '名',
    lastname: '姓',
    province: '省份',
    district: '区',
    subdistrict: '街道',
    addressNumber: '地址',
    setAsDefaultAddress: '设为默认地址',
    setAsTaxAddress: '设为税务发票地址',
    setAsShippingAddress: '设为配送地址',
    contact: '联系方式',
    setAsDefault: '设为默认',
    addressLists: '地址列表',
    default: '默认',
    taxAddress: '税务发票',
    shippingAddress: '配送',
    addAddress: '添加',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    by: '由',
    readyForSale: '可售',
    sold: '已售',
    delete: '删除',
    items: '商品',
    itemDiscount: '商品折扣',
    failedToSave: '保存失败！',
    dateOfBirth: '出生日期',
    menu: '菜单',
    dashboardMenu: '仪表板',
    transactionMenu: '交易',
    currentBillMenu: '当前账单',
    reportMenu: '报表',
    orderDeviceMenu: '点餐设备',
    memberMenu: '会员',
    inventoryMenu: '库存',
    productMenu: '商品',
    selfOrderMenu: '销售渠道',
    settingMenu: '设置',
    salesReportByDate: '按日期销售额',
    salesReportByBill: '按账单详情销售额',
    salesQuantitySummaryByProductReport: '按商品销售额',
    quantitySummaryByPLUReport: '按商品销售额（PLU）',
    nonSellingProduct: '未销售商品',
    salesSummaryByCashierReport: '按收银员销售额',
    salesSummaryByCategoryReport: '按类别销售额',
    paymentReport: '付款',
    salesTaxReport: '销售税',
    drawerReport: '收银箱',
    voidBillReport: '作废账单',
    timesheetReport: '考勤',
    stockInByListReport: '按商品入库',
    stockOutByListReport: '按商品出库',
    nonAdjustStockProductReport: '未调整库存商品',
    exportProductReport: '导出商品',
    salesSummaryByOrderReport: '按点餐设备',
    salesSummaryProductByOrderReport: '按商品',
    voidBillByOrderReport: '作废账单',
    inventoryReport: '库存报表',
    inventoryReportByPLU: 'PLU 库存报表',
    inventoryReportBySerial: '序列号库存报表',
    stockMovement: '库存变动',
    stockInDocument: '入库单据',
    stockOutDocument: '出库单据',
    adjustStockDocument: '库存调整单据',
    selfOrder: '自助点餐',
    cashier: '收银员',
    permission: '权限',
    menuSetting: '菜单设置',
    management: {
        txtManagement: '管理',
        user: '账户',
        shopBranch: '店铺和分店',
        productManagement: '商品',
        unitManagement: '单位',
        categorytManagement: '类别',
        inventory: '库存',
        stockIn: '入库',
        stockOut: '出库',
        adjustStock: '库存调整',
        checkStock: '盘点库存',
        stockMovement: '库存变动',
        transferStock: '库存调拨',
        reportByPLU: 'PLU 库存报表',
        reportBySKU: '库存报表',
        txtreportBySKU: '库存报表',
        txtreportByPLU: 'PLU 库存报表',
        stockInDoc: '入库单据',
        stockOutDoc: '出库单据',
        adjustStockDoc: '库存调整单据',
        transferStockDoc: '库存调拨单据',
        transferStockInDoc: '调入库存单据',
        transferStockOutDoc: '调出库存单据',
    },
    report: {
        dashboard: '仪表板',
        transaction: '交易',
        currentbill: '当前账单',
        daily: '按日期',
        txtdaily: '按日期销售报表',
        dailyDes: '按日期销售详情',
        sellbyProduct: '按账单详情',
        txtsellbyProduct: '按账单详情销售报表',
        sku: '按商品',
        txtsku: '按商品销售报表',
        plu: '按商品（PLU）',
        textPlu: '按商品销售报表（PLU）',
        paymentreport: '付款报表',
        txtpaymentreport: '付款报表',
        timesheet: '考勤',
        txtTimesheet: '考勤报表',
        unsell: '未销售商品',
        txtUnsell: '未销售商品',
        byCategory: '按类别',
        txtbyCategory: '按类别销售报表',
        byCashier: '按收银员',
        txtbyCashier: '按收银员销售报表',
        salesTax: '销售税报表',
        txtSalesTax: '销售税报表',
        voidbill: '作废账单',
        txtvoidbill: '作废账单报表',
        closedSale: '销售结算',
        txtCloseSale: '收银箱报表',
        salesByOrder: '销售汇总',
        productByOrder: '按商品',
        unsalesByOrder: '作废账单',
        txtDeliveryRoport: '按配送付款报表',
        txtCustomReport: '按自定义付款报表',
        txtSalesByOrder: '按点餐设备商品销售',
        txtDailyOrder: '按点餐设备销售报表',
        txtViodOrder: '按点餐设备作废账单',
        nonadjust: '未调整库存商品',
        txtnonadjust: '未调整库存商品报表',
        stockInReport: '按商品入库报表',
        stockOutReport: '按商品出库报表',
        stockIn: '按商品入库',
        stockOut: '按商品出库',
        exportProduct: '导出商品',
        txtExportProduct: '导出商品报表',
        cashDrawer: '收银箱',
        txtCashDrawerr: '现金管理报表',
        cashRevenue: '现金收入',
    },
    drawer: {
        cashDrawer: '收银箱',
        txtCashDrawerr: '现金管理报表',
        cashRevenue: '收支汇总',
        txtcashRevenue: '收支汇总报表',
    },
    member: {
        txtmember: '会员',
        register: '店铺注册（LINE OA）',
        loyaltyPoint: '积分',
        storeCredit: '储值',
        deal: '优惠',
        giftVoucher: '礼品券',
        referral: '邀请',
        crm: 'Silom CRM',
    },
    unableStockDescription: '单据创建后已有库存更新，无法编辑商品。',
    noItem: '暂无项目',
    enterProductName: '输入商品名称',
    ByCategory: '按类别',
    ByCategoryDetail: '按类别详情',
    maximum: '最大',
    selectZone: '选择区域',
    minimum: '最小',
    unlimited: '无限制',
    startTime: '开始时间',
    endTime: '结束时间',

    "errorMessages": {
        "qrExpired": "QR Code 已过期",
        "qrNotFound": "未找到 QR Code",
        "paymentSuccess": "支付成功",
        "invalidQrType": "QR Code 类型无效",
        "tableMoved": "已换桌",
        "receiptVoided": "收据已作废"
    },
    "errorDescriptions": {
        "qrExpired": "您使用的 QR Code 已过期。<br>请联系服务员获取帮助。",
        "qrNotFound": "未找到点餐 QR Code 信息。<br>请联系服务员。",
        "paymentSuccess": "感谢您的惠顾！",
        "invalidQrType": "请联系服务员获取动态 QR Code。",
        "tableMoved": "请联系服务员获取新的 QR Code。",
        "receiptVoided": "感谢您的惠顾。<br>如需帮助请联系服务员。"
    },
    waitForServe: '等待上菜',
    DineInPaymentDetails: '付款',
    silomPayProDesp: 'Silom Pay Easy 安全支付',
    billDetail: '账单详情',
    minute: '分钟',
    paymentTImeExpired: '已超时',
    openApp: '打开应用',
    callPayStaffSuccess: '已呼叫服务员<br>请等待协助完成支付',
    account: '账户',
    refNumber: '参考号',
    QRCodeBBL: '信用卡 QR Code',
    trackOrderStatus: '跟踪订单状态',
    all: '全部',
    noOrderThisStatus: '该状态下暂无订单',
    orderCompleteThanks: '感谢您的惠顾！',
    OnPreparingYourOrder: '正在准备您的订单...',
    goToTracking: '前往跟踪页面',
    "dine-in": '堂食',
    typeOfOrder: '订单类型',
    queue: '排队',
    cooking: '烹饪中',
    orderedAt: '下单时间',
    orderTimeStatus: '下单时间',
    acceptTimeStatus: '接单时间',
    estTimeStatus: '预计时间',
    newOrderDelivery: '新订单',
    acceptOrderDelivery: '已接单',
    readyToServeDelivery: '准备就绪',
    orderCompleted: '订单结束',
    orderCanceled: '订单已取消',
    readyToShip: '待发货',
    scanForPayment: '扫码支付',
    orderType: '订单类型',
    welcomeBack: "欢迎回来 👋",
    welcomeBackDespt: "登录继续点餐",
    orLoginWith: "或使用以下方式登录",
    dontHaveAccount: '还没有账户？',
    register: '注册',
    fullName: "姓名",
    fullNameDespt: '您的姓名',
    emailDespt: '您的邮箱',
    createPassword: '创建密码',
    alreadyHaveAccount: '已有账户',
    verifyEmail: '验证邮箱',
    enterOTPSentTo: '输入发送到的 OTP ',
    enterSixOTP: '输入6位 OTP',
    verifyOTP: '验证 OTP',
    weWillSentOTPEmail: '我们将向您的邮箱发送 OTP',
    enterYourEmail: '输入您的邮箱',
    confirmNewPassword: '确认新密码',
    sendOTP: '发送 OTP',
    addPhoneNumber: '添加手机号',
    addPhoneForRegister: '添加手机号注册',
    enterPhone: '输入手机号',
    phoneUsed: '手机号已被使用',
    emailUsed: '邮箱已被使用',
    enterPassword: '请输入密码',
    registerEmail: '注册邮箱',
    otpInvalid6: "请输入有效的6位 OTP。",
    emailVerified: "邮箱验证成功！",
    emailOrPasswordInvalid: '邮箱或密码不正确',
    pleaseEnterEmail: '请输入邮箱',
    otpSentToEmail: "OTP 已发送至邮箱",
    passwordNotMatch: "密码不一致",
    resetPasswordCompleted: '密码重置成功！',
    failResetPassword: '重置密码失败',
    completePhoneFail: '手机号注册失败',
    plaseEnterValidEmail: '请输入有效的邮箱地址',
    invalidPhoneNumber: '手机号须以 06、08 或 09 开头且为10位数字',
    example: '示例',
    passwordSet: "需超过6个字符且包含数字",
    SelectTableToAdd: '餐桌',
    availableTable: '可用',
    unAvailableTable: '不可用',
    SelectTableToAddDesp: '选择堂食餐桌<br>注意：如需换桌请联系服务员',
    updatedStaus: '状态已更新',
    otpExpired: 'OTP 已过期',
    and: "和",
    emailOTP: "邮箱 OTP",
    emailOTPDesp: "输入通过邮箱收到的 OTP",
    phoneOTP: "手机 OTP",
    phoneOTPDesp: "输入通过短信收到的 OTP",
    checkSpamBox: '* 如未收到邮件，请检查垃圾邮件文件夹。有时可能需要几分钟才能到达。',
    DineInPaymentPending: '待付款',
    visitProceedPayment: '前往付款',
    proceedPayment: "继续付款",
    proceedPaymentDesp: "此账单正在处理付款。<br>如需加点，<br>请先取消当前付款",
    queueIndex: '排队',
    otpSentToPhone: 'OTP 已通过短信发送。',
    failToSendOTP: 'OTP 发送失败',
    somethingWentWrong: '出了点问题',
    tableHasNoOrder: '此桌暂无订单',
    kbankProceedPaymentDesp: '此账单正在处理付款。<br>如需加点或更换支付方式，<br>请先取消当前付款'
,
  openHours: '营业',
}

export default messages
